export const REFRESH_TIMEOUT = 3000;

export const STATUS = {
    CONCENTRATED: 'concentrated',
    LAPSED: 'lapsed',
    ABSENT: 'absent'
};

export const STATUS_TABLE = [
    STATUS.CONCENTRATED,
    STATUS.LAPSED,
    STATUS.ABSENT
];
